import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Flex } from 'components/ui';
import { colors } from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import CartLayoutEN from 'components/RwdBasket/Carts/CartLayout/locales/CartLayout_en_US';
import CartLayoutFR from 'components/RwdBasket/Carts/CartLayout/locales/CartLayout_fr_CA';

function OnlyFewLeft() {
    const getText = localeUtils.getLocalisedDataFromResource(CartLayoutEN, CartLayoutFR);

    return (
        <Flex
            backgroundColor={colors.red}
            color={colors.white}
            width={'fit-content'}
            paddingX={['6px', 2]}
            paddingY={'2px'}
            marginTop={3}
            borderRadius={2}
            fontSize={['10px', 'xs']}
            fontWeight={'bold'}
            justifyContent={'center'}
            css={{ textTransform: 'uppercase' }}
            children={getText('onlyFewLeft')}
        />
    );
}

export default wrapFunctionalComponent(OnlyFewLeft, 'OnlyFewLeft');
